import { Box, Chip, Stack, Typography } from "@mui/material"
import { getRuleImpactLabel } from "./rule-impact-label"

export function VariantBreakdownRuleImpactRow({ item }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            sx={{ px: 2, py: 1, borderBottom: 1, borderColor: "divider", "&:last-child": { borderBottom: 0 } }}
        >
            <Box sx={{ flex: 2 }}>
                <Typography variant="body2">{getRuleImpactLabel(item)}</Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
                <Chip label={actionChipLabel(item)} size="small" sx={{ height: 22 }} />
            </Box>
            <Box sx={{ flex: 1, textAlign: "right" }}>
                <Typography variant="body2" color="text.secondary">
                    {item.taskCount} tasks
                </Typography>
            </Box>
        </Stack>
    )
}

function actionChipLabel(item) {
    const action = item.actionType ?? item.action
    if (action !== "modifier") return action
    if (item.costKind === "fixed" && item.fixedAmount != null) {
        const sign = item.fixedAmount >= 0 ? "+" : ""
        return `modifier ${sign}${item.fixedAmount} fixed`
    }
    if (item.multiplier != null) return `modifier x${item.multiplier}`
    return action
}
